var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGarbageTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d3b24b;}.cls-2{fill:#fed65c;}.cls-3{fill:#ea8536;}.cls-4{fill:#cf6614;}.cls-5{fill:#fbedc1;}.cls-6{fill:#cad0d8;}.cls-7{fill:#293b58;}.cls-8{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_533",
    "data-name": "Warstwa 533"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30.2 19.21 13.15 19.21 13.15 8.17 24.53 8.15 30.2 16.22 30.2 19.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.67 22.67 11.67 8.67 22.43 8.67 29.67 19.01 29.67 22.67 11.67 22.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.17,9.17l7,10v3h-17v-13h10m.52-1H11.17v15h19V18.85L30,18.59l-7-10-.3-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2.67,22.67l0-5.17a1.62,1.62,0,0,1,.26-.88l3.66-5.39a1.24,1.24,0,0,1,1-.56h4.07v12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.59,11.17h3.57v11h-8l0-4.67a1.08,1.08,0,0,1,.18-.6L7,11.51a.77.77,0,0,1,.63-.34m0-1A1.76,1.76,0,0,0,6.13,11L2.48,16.34a2,2,0,0,0-.35,1.17l0,4.67v1h10v-13H7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.4,11.17H14.17v-2h8l7,10v1h-2Zm3.46-2H23.12l1.41,2h1.73Zm2,3H25.14l1.41,2h1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.06,25a1.87,1.87,0,1,1,1.87-1.87A1.87,1.87,0,0,1,24.06,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M24.06,22a1.12,1.12,0,1,1-1.12,1.12A1.12,1.12,0,0,1,24.06,22m0-1.5a2.62,2.62,0,1,0,2.62,2.62,2.62,2.62,0,0,0-2.62-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M18.29,25a1.87,1.87,0,1,1,1.87-1.87A1.87,1.87,0,0,1,18.29,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M18.29,22a1.12,1.12,0,1,1-1.12,1.12A1.12,1.12,0,0,1,18.29,22m0-1.5a2.62,2.62,0,1,0,2.62,2.62,2.62,2.62,0,0,0-2.62-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M6.29,25a1.87,1.87,0,1,1,1.87-1.87A1.87,1.87,0,0,1,6.29,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M6.29,22a1.12,1.12,0,1,1-1.12,1.12A1.12,1.12,0,0,1,6.29,22m0-1.5a2.62,2.62,0,1,0,2.62,2.62,2.62,2.62,0,0,0-2.62-2.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "9.17 16.17 2.59 16.17 5.3 12.17 9.17 12.17 9.17 16.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "3.8 16.17 2.59 16.17 5.3 12.17 6.51 12.17 3.8 16.17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarbageTruck);
export default __webpack_public_path__ + "static/media/garbageTruck.615abd83188ae6b05ee5a416649774a4.svg";
export { ForwardRef as ReactComponent };